import React from "react"

import Layout from "../components/layout"
import Home from "../components/home"
import About from "./about"
// import Experience from "./experience"
import Projects from "./projects"

import indexStyle from "./index.module.scss"

const IndexPage = props => {
  return (
    <div>
      <Layout>
        <main>
          <div className={indexStyle.container}>
            <Home />
            <div className={indexStyle.navi}></div>
          </div>
          <About />
          {/* <Experience /> */}
          <Projects />
        </main>
      </Layout>
    </div>
  )
}
 
export default IndexPage;